<script>
	import Bubble from '$lib/Components/Layout/Bubble/Bubble.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Awards from '$lib/PageSections/Awards/Awards.svelte';
	import BuildYourOwnEstimate from '$lib/PageSections/BuildYourOwnEstimate/BuildYourOwnEstimate.svelte';
	import CustomizeYourInsert from '$lib/PageSections/CustomizeYourInsert/CustomizeYourInsert.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';

	import insert from './images/case-window-insert.png';
	import SectionProductTypes from './sections/SectionProductTypes.svelte';
</script>

<SectionProductTypes />
<CustomizeYourInsert />

<Section backgroundColor="white">
	<h2>The Benefits of Using Window Inserts</h2>
	<p>
		When you want to improve your windows without the expense or inconvenience
		of replacing them, Indow window inserts are a smart and cost-effective
		solution. Not only is storm window installation cheaper than window
		replacement, but it also offers several benefits, such as:
	</p>
	<Bubble backgroundColor="grey-light">
		<ul>
			<li>Reduced noise pollution.</li>
			<li>Lowered energy costs.</li>
			<li>Enhanced privacy.</li>
			<li>Easy installation.</li>
			<li>Convenience.</li>
			<li>Preserves the style of a historic home.</li>
		</ul>
	</Bubble>
	<p>
		Our patented silicone compression tubing secures Indow interior storm
		windows firmly in position, creating an airtight seal between the insert and
		window frame. Yet, they're easy to put in and take out. Inserts up to 14
		square feet can be comfortably handled by one person. To discuss the size of
		your windows and get an estimate on cost, fill out the form below.
	</p>
	<Image src={insert} alt="Customer measuring custom storm window inserts." />
</Section>

<Section backgroundColor="white">
	<h2>Pricing &amp; Consultations</h2>
	<p>
		Indow is proud to offer an easy-to-use, energy-efficient solution for
		increasing comfort, quiet and savings at home. Upgrade the functionality of
		your windows while avoiding the expense of replacing them by installing our
		elegantly effective inserts. We tailor custom storm window inserts to your
		exact specifications. To learn more, fill out this form for a free estimate!
	</p>
</Section>

<BuildYourOwnEstimate />
<GetAFreeEstimate />
<Reviews />
<Awards />
